import { render, staticRenderFns } from "./RefundAttentionAdviser.vue?vue&type=template&id=b4d07e50&"
import script from "./RefundAttentionAdviser.vue?vue&type=script&lang=ts&"
export * from "./RefundAttentionAdviser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox, CFlex: require('@chakra-ui/vue').CFlex})
